const FEEDBACK_TEMPLATE_EXCEPTION_NO_PERMISSION = () => (
    <div>
        <h1>No Permission</h1>
        Sorry, but you have no permission to perform the action.
    </div>
);

const FEEDBACK_TEMPLATE_EXCEPTION_NO_TEMPLATE = () => (
    <div>
        <h1>No Template</h1>
        We couldn't find the matching template for your performed action.
    </div>
);

export default {
    FEEDBACK_TEMPLATE_EXCEPTION_NO_PERMISSION,
    FEEDBACK_TEMPLATE_EXCEPTION_NO_TEMPLATE,
};
